// @ts-nocheck

export const localeCodes =  [
  "nl",
  "en"
]
export const localeLoaders = {
  nl: [
    {
      key: "locale_nl_46json_37b38a4a",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_f08b6577",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/3b12b8fa" /* webpackChunkName: "config_vue_45i18n_46ts_3b12b8fa" */)
]
export const normalizedLocales = [
  {
    code: "nl",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "en",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

